// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessageGP<T extends Record<string, any>>(error: T) {
  if (error.isAxiosError) {
    const objErrors = Object.values(
      error.response.data?.errors as Record<string, string[]>,
    ).flat();

    return objErrors[0] || 'Não foi possível finalizar a ação, tente novamente';
  }

  return error.message;
}
